import React from "react";

export const IndicativeBadge = ({ className = "" }) => (
  <span
    data-testid="indicative-badge"
    title="These figures are modelled estimates, not live reported prices. Real data feeds are being rolled out."
    className={`inline-flex items-center gap-1.5 px-2.5 py-1 text-[11px] font-semibold uppercase tracking-wide bg-[#FBBF24]/20 text-[#B45309] border border-[#FBBF24]/50 ${className}`}
  >
    <svg width="11" height="11" viewBox="0 0 256 256" fill="currentColor" aria-hidden="true">
      <path d="M236.8 188.09L149.35 36.22a24.76 24.76 0 0 0-42.7 0L19.2 188.09a23.51 23.51 0 0 0 0 23.72A24.35 24.35 0 0 0 40.55 224h174.9a24.35 24.35 0 0 0 21.33-12.19a23.51 23.51 0 0 0 .02-23.72ZM120 104a8 8 0 0 1 16 0v40a8 8 0 0 1-16 0Zm8 88a12 12 0 1 1 12-12a12 12 0 0 1-12 12Z" />
    </svg>
    Indicative — modelled estimate
  </span>
);

export default IndicativeBadge;
